(function () {
  function placeWishlistHosts(root = document) {
    root.querySelectorAll('.product-item').forEach((card) => {
      const imgWrap = card.querySelector('.product-item__image-wrapper');
      const host = card.querySelector('ooo-wl-access-button, ooo-wl-product-card-button');
      if (imgWrap && host && host.parentElement !== imgWrap) {
        imgWrap.appendChild(host);
      }
    });
  }

  const run = () => placeWishlistHosts(document);

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', (e) => placeWishlistHosts(e.target || e.detail?.section));
  document.addEventListener('facet:updated', run);
  window.addEventListener('resize', run);

  // Handle dynamic updates (AJAX grids, etc.)
  const mo = new MutationObserver(() => placeWishlistHosts(document));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
